/*
 * © 2021 Thoughtworks, Inc.
 */

import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(({ spacing }) => ({
  boxContainer: {
    padding: spacing(3, 10),
  },
  loadingContainer: {
    padding: spacing(3, 10),
    marginTop: 62,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
  },
  pageContainer: {
    height: '100%',
    overflowY: 'scroll',
  },
}))

export default useStyles
